import { groupBy, mapValues, values, cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import {
   DATE_TIME_FIELD_KEY,
   CRITERIA_HEADER_DETAILS,
   SEARCH_CRITERIA_CONFIG,
   monthNames,
} from './constants.js';
import { DateUtil } from './date-util';

export const getClonedObject = (inputObject) =>
   inputObject ? cloneDeep(inputObject) : inputObject;

export const groupByMultipleProperties = (collection, keys) => {
   if (!keys.length) {
      return collection;
   }
   const first = keys[0];
   const rest = keys.slice(1);
   return mapValues(groupBy(collection, first), (eachValue) => {
      return {
         [first]: eachValue[0][first],
         subRows: values(groupByMultipleProperties(eachValue, rest)),
      };
   });
};
const calculateGroup = (item, screen) => {
   let name = '';
   SEARCH_CRITERIA_CONFIG.find((list) => {
      list.categoryName !== 'Table' &&
         list.categoryName !== 'Products' &&
         list.categoryDetails.find((subList) => {
            if (
               subList.keyCode?.toLowerCase() === item &&
               list.screen.includes(screen)
            )
               name = list.categoryName;
         });
   });
   return name;
};

export const emptyValidation = (value) => {
   return value ? value : '';
};

export const amountEmptyFieldValidation = (value) => {
   return value ? value : 0;
};
export const dateFormat = (date) => {
   return date
      ? DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY)
           .toString()
           .toUpperCase()
      : '';
};
export const dateTimeFormat = (date) => {
   return date
      ? DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY_TIME)
           .toString()
           .toUpperCase()
      : '';
};

export const calculateHeader = (data, screen) => {
   return Object.keys(data).map((item) => {
      if (
         item !== 'distributionGroupLogs' &&
         item !== 'createdAt' &&
         item !== 'lastUpdatedAt' &&
         item !== 'timeStampAt'
      )
         return {
            key: item,
            width: 0,
            groupName: calculateGroup(item, screen),
            isAscending: false,
            isDecending: false,
            isDefault: true,
            filterValue: '',
            isFilterOpen: false,
            isShowFilterControls: false,
            title: CRITERIA_HEADER_DETAILS.find((list) => list.KEY === item)
               .VALUE,
            isFilterApply: false,
            screen: screen,
         };
   });
};
export const calculateDistributionHeader = (data) => {
   return Object.keys(data).map((item) => {
      if (
         item !== 'distributionGroupLogs' &&
         item !== 'createdAt' &&
         item !== 'lastUpdatedAt' &&
         item !== 'timeStampAt'
      )
         return {
            key: item,
            width: 0,
            groupName: 'distributionGroup',
            isAscending: false,
            isDecending: false,
            isDefault: true,
            filterValue: '',
            isFilterOpen: false,
            isShowFilterControls: false,
            title: CRITERIA_HEADER_DETAILS.find((list) => list.KEY === item)
               .VALUE,
            isFilterApply: false,
         };
   });
};
export const calculateJoinData = (primary, secondary) => {
   const result = secondary.map((list, index) => {
      return { ...primary[index], ...list };
   });
   return result;
};
export const calculateMergeData = (primary, secondary) => {
   const result = secondary.map((list, index) => {
      // delete list.distributionGroupLogs;
      return { ...primary[index], ...list };
   });
   return result;
};
export const handleKeyPress = (event, code) => {
   if (
      (!/[0-9\s%_,]/.test(event.key) &&
         (code === 'RTG' || code === 'MIN ST' || code === 'MAX ST')) ||
      (!/^[0-9\s%_,]+$/.test(event.key) &&
         (code === 'TAR' || code === 'OWRT' || code === 'DG')) ||
      (!/^[\d\.\d\s%_]*$/.test(event.key) &&
         (code === 'AMT' ||
            code === 'SUR' ||
            code === 'YQ' ||
            code === 'YR' ||
            code === 'TAX' ||
            code === 'TTL' ||
            code === 'AP' ||
            code === 'DC' ||
            code === 'FARE')) ||
      (!/^[a-zA-Z0-9\s%_|,]+$/.test(event.key) && code === 'DOW') ||
      (!/^[a-zA-Z\s%_,]+$/.test(event.key) &&
         (code === 'ORG' ||
            code === 'CUR' ||
            code === 'DES' ||
            code === 'CAB' ||
            code === 'RBD' ||
            code === 'FTC' ||
            code === 'DOW TC' ||
            code === 'SEAS TC' ||
            code === 'PTC' ||
            code === 'REL IND' ||
            code === 'IGN ERR' ||
            code === 'LFC' ||
            code === 'TAX IND' ||
            code === 'EX IND' ||
            code === 'JUSTIFICATION')) ||
      (!/^[a-zA-Z0-9\s%_,]+$/.test(event.key) &&
         (code === 'FBC' ||
            code === 'CXR' ||
            code === 'FT' ||
            code === 'RULE' ||
            code === 'BO DT' ||
            code === 'TKT DSG' ||
            code === 'VCC' ||
            code === 'GFS')) ||
      (!/^[a-zA-Z0-9\s%_:,]+$/.test(event.key) && code === 'REC DT') ||
      (!/^[a-zA-Z0-9\s%_,-]+$/.test(event.key) &&
         (code === 'FT SEAS DT' ||
            code === 'FT TVL DT' ||
            code === 'FT BO DT' ||
            code === 'SEAS DT' ||
            code === 'RULE TVL DT' ||
            code === 'APPL DT'))
   )
      event.preventDefault();
};
export const calculateParsingData = (defaultData) => {
   let mergedSecondaryTable = [];
   let table = [];
   let obj = {};
   defaultData.map((list, index) => {
      if (index === 0) {
         table.push({
            title: list.categoryTitle,
            count: Object.keys(list.data[0]).length,
            sepration: Object.keys(list.data[0]).length,
            keys: Object.keys(list.data[0]),
         });
      } else {
         table.push({
            title: list.categoryTitle,
            count: table[index - 1].count + Object.keys(list.data[0]).length,
            sepration: Object.keys(list.data[0]).length,
            keys: Object.keys(list.data[0]),
         });
      }
      list.data.map((subList, subIndex) => {
         mergedSecondaryTable[subIndex] = {
            ...mergedSecondaryTable[subIndex],
            ...subList,
         };
         if (index === 0 && subIndex === 0) {
            obj = { ...subList };
         } else if (subIndex === 0) {
            obj = { ...obj, ...subList };
         }
      });
   });
   return {
      tableTitle: table,
      tableData: obj,
      mergedSecondaryTable: mergedSecondaryTable,
   };
};
export const calculateSeparationTableCaption = (totalList) => {
   let firstSeparatorIndex = null;
   totalList.map((list, index) => {
      if (list.key.indexOf(' ') >= 0) {
         if (!firstSeparatorIndex) firstSeparatorIndex = index;
      }
   });
   return firstSeparatorIndex;
};
export const calculateResultDetailsUnique = (
   collection,
   headers,
   item,
   type
) => {
   headers.map((menuList) => {
      const uniqueResult = [
         ...new Set(
            collection.map(
               (list) => list[menuList.key] && list[menuList.key].toString()
            )
         ),
      ];
      uniqueResult.sort();
      if (menuList.key !== item.key) {
         const response = uniqueResult.map((item) => {
            return {
               key: item,
               value: true,
            };
         });
         menuList.uniqueFilters = getClonedCopyCollections(response);
      } else if (type === 'clear' && menuList.key === item.key) {
         const response = menuList.uniqueFilters.filter((subItem) =>
            uniqueResult.includes(subItem.key)
         );
         menuList.uniqueFilters = getClonedCopyCollections(response);
      }
   });
   return headers;
};
export const generateTableObjects = (totalList) => {
   let primaryCollection = [];
   let secondaryCollection = [];
   let fullCollection = [];
   totalList.forEach((list) => {
      if (!list.id) list.id = createUniqueId();
      const {
         org,
         des,
         cxr,
         fbc,
         tar,
         ft,
         rtg,
         con,
         id,
         isSelect,
         isReject,
         selectedField,
         selectedColumn,
         uac,
         isInsert,
         status,
         ...secondary
      } = list;
      const primary = {
         org,
         des,
         cxr,
         fbc,
         tar,
         ft,
         rtg,
         con,
         id,
         isSelect,
         isReject,
         selectedField,
         selectedColumn,
         uac,
         isInsert,
         status,
      };
      const secondaryTable = {
         selectedColumn,
         selectedField,
         isSelect,
         isReject,
         id,
         cxr,
         uac,
         isInsert,
         status,
         ...secondary,
      };

      primaryCollection.push(primary);
      secondaryCollection.push(secondaryTable);
      fullCollection.push(list);
   });
   return { primaryCollection, secondaryCollection, fullCollection };
};

export const updateData = (totalList, item, type, value) => {
   const updatedResult = totalList.map((list) => {
      if (type === 'sorting') {
         if (list.key === item.key) {
            list.isShowFilterControls = !list.isShowFilterControls;
         } else {
            list.isFilterOpen = false;
            list.isShowFilterControls = false;
         }
      } else if (type === 'filterChanging') {
         if (list.key === item.key) {
            list.filterValue = value;
            list.isFilterApply = value ? true : false;
         } else {
            list.filterValue = list.filterValue ? list.filterValue : '';
            list.isFilterApply = list.filterValue ? true : false;
         }
      } else if (type === 'closePopup' && list.key === item.key) {
         list.isFilterOpen = false;
         list.isShowFilterControls = false;
      } else {
         if (list.key === item.key) list.isFilterOpen = true;
         else list.isFilterOpen = false;
      }
      return list;
   });
   return updatedResult;
};
export const sortTableHeaders = (tableData, fieldKey) => {
   const alphabeticallySortedHeaders = tableData.sort(
      (previousValue, nextValue) => {
         if (!parseInt(previousValue))
            return previousValue.toString().localeCompare(nextValue.toString());
         else if (
            fieldKey !== 'rec dt' &&
            fieldKey !== 'eff dt' &&
            fieldKey !== 'gfs dt'
         )
            return parseInt(previousValue - nextValue);
         else
            return (
               new Date(previousValue.toString()) -
               new Date(new Date(nextValue.toString()))
            );
      }
   );
   return alphabeticallySortedHeaders;
};
export const calculateResultDetails = (result, joinHeaders) => {
   joinHeaders.map((menuList) => {
      if (menuList) {
         const uniqueResult = [
            ...new Set(
               result.map((list) =>
                  list[menuList.key] || list[menuList.key] === 0
                     ? list[menuList.key].toString()
                     : ''
               )
            ),
         ];
         uniqueResult.sort();
         const response = uniqueResult.map((item) => {
            return {
               key: item,
               value: true,
            };
         });
         menuList.uniqueFilters = response.length > 0 ? response : [];
         menuList.defaultuniqueFilters =
            response.length > 0 ? [...response] : [];
      }
   });
   return joinHeaders;
};
export const handleNonNumberKeyPress = (event) => {
   if (!/^[0-9,]+$/.test(event.key)) event.preventDefault();
};
export const getClonedCopyCollections = (list) => {
   return list.map((item) => {
      return { ...item };
   });
};

export const updateRecords = (item, totalList) => {
   let currentRecord = 0;
   const updatedResult = totalList.map((list) => {
      if (list.key === item.key) {
         if (item.isDefault || item.isDecending) {
            list.isAscending = true;
            list.isDefault = false;
            list.isDecending = false;
         } else if (item.isAscending) {
            list.isDecending = true;
            list.isAscending = false;
         }
         currentRecord = list;
      }

      return list;
   });
   return { updatedResult, currentRecord };
};
const formatValues = ({ key, values }) => {
   return DATE_TIME_FIELD_KEY.includes(key)
      ? DateUtil.formatUtcDate(
           values.toString().toUpperCase(),
           DateUtil.DATE_FORMATS
              .DOMAIN_DATE_TIME_TIMEZONE_WITH_MILLI_SECONDS_PATTERN
        )
      : values.toString().toUpperCase();
};
export const deleteItems = ({ ...result }) => {
   Object.keys(result).map((list) => {
      const rowItems = result[list].map((item) => {
         const defaultItems = { ...item };
         delete defaultItems.keyCode;
         delete defaultItems.title;
         defaultItems.value = formatValues(defaultItems);
         delete defaultItems.values;
         return (item = defaultItems);
      });
      result[list] = rowItems;
   });
   return result;
};
export const parsingRequestData = (...parsingData) => {
   let isEmptyValue = false;
   const isAnyEmptyObject = [];
   let defaultParsingData = parsingData;
   const newOriginalObject = {};
   const removedList = getClonedCopyCollections(defaultParsingData[0]).filter(
      (list) => {
         const subListResult = list.categoryDetails.filter((sublist) => {
            if (sublist.values.length > 0) {
               isEmptyValue = sublist.values.some(
                  (item) => item === 'Invalid date' || item.trim() === ''
               );
               if (!isEmptyValue) return sublist;
            }
         });
         if (subListResult.length > 0) {
            list.categoryDetails = subListResult;
            return list;
         }
      }
   );
   removedList.filter((item) => {
      newOriginalObject[
         item.categoryName.toString().charAt(0).toLowerCase() +
            item.categoryName.slice(1).split(' ').join('') +
            (item.categoryName !== 'Fare Class' &&
            item.categoryName !== 'Distribution Groups'
               ? 's'
               : '')
      ] = [...item.categoryDetails];
   });
   if (Object.values(newOriginalObject).length === 0) isEmptyValue = true;
   else isEmptyValue = false;
   return { data: newOriginalObject, isEmptyValue: isEmptyValue };
};

export const copyTableData = (tabelData) => {
   const header = Object.keys(tabelData[0]).filter(
      (item) => item !== 'distributionGroupLogs' && item !== 'id'
   );
   var copyTable = document.createElement('table');
   var copyTableBody = document.createElement('tbody');
   var headerRow = document.createElement('tr');
   const headerData = header.map((list) => {
      return `<td>${list}</td>`;
   });
   headerRow.innerHTML = headerData.slice('').join('');
   copyTableBody.appendChild(headerRow);
   tabelData.map((data) => {
      var row = document.createElement('tr');
      const tableRow = header.map((list) => {
         return `<td>${data[list]}</td>`;
      });
      row.innerHTML = tableRow.slice('').join('');
      copyTableBody.appendChild(row);
   });
   copyTable.appendChild(copyTableBody);
   document.body.appendChild(copyTable);
   navigator.clipboard.writeText(copyTable.innerText);
   copyTable.remove();
   return true;
};

export const displayDateTextMethod = (month, year, day) => {
   const monthNum = parseInt(month || '', 10);
   if (monthNames[monthNum - 1] && day && year) {
      return `${day}${monthNames[monthNum - 1]}${year.toString().substring(2)}`;
   }
   return '';
};

export const formatDate = (event) => {
   const dateObj = new Date(event);
   const day = dateObj.getDate();
   const month = dateObj.getMonth() + 1;
   const year = dateObj.getFullYear();
   return displayDateTextMethod(month, year, day);
};

export const getHostCarrierCode = () => {
   return sessionStorage.getItem('carrierCode') ?? null;
};

export const createUniqueId = () => {
   return `${uuidv4()}-${Date.now()}`;
};
